import TagInputField from '../project-widgets/TagInputField';

const INP = {
  width: '100%', padding: '10px 13px', borderRadius: 5,
  background: 'rgba(255,255,255,.05)', border: '1px solid rgba(201,168,76,.18)',
  color: '#fff', fontSize: '.84rem', fontFamily: 'var(--sans)',
  outline: 'none', boxSizing: 'border-box',
};
const LBL = {
  fontSize: '.6rem', color: 'rgba(255,255,255,.36)',
  letterSpacing: '.1em', textTransform: 'uppercase', marginBottom: 5, display: 'block',
};

const UNIT_TYPES = [
  'Apartment', 'Duplex', 'Penthouse', 'Townhouse',
  'Twin House', 'Villa', 'Chalet', 'Studio', 'Commercial',
];

const AMENITIES = [
  'Clubhouse', 'Swimming Pool', 'Gym', '24/7 Security',
  'Landscaped Gardens', 'Kids Area', 'Jogging Track',
  'Retail Area', 'Mosque', 'Underground Parking',
  'Smart Home', 'CCTV', 'Tennis Court', 'Spa',
];

export default function Step4Specs({ form, update }) {
  const sectionHead = {
    color: 'rgba(255,255,255,.85)', fontSize: '.82rem', fontWeight: 700,
    marginBottom: '1rem', marginTop: '.5rem',
    paddingBottom: '.5rem', borderBottom: '1px solid rgba(201,168,76,.1)',
    display: 'flex', alignItems: 'center', gap: 7,
  };

  return (
    <div>
      <div style={sectionHead}>
        <span style={{ color: 'var(--gold)' }}>④</span> Property Specifications
      </div>

      {/* Unit Types */}
      <div style={{ marginBottom: '1.4rem' }}>
        <TagInputField
          label="Available Unit Types"
          values={form.unitTypes}
          onChange={v => update({ unitTypes: v })}
          presets={UNIT_TYPES}
          placeholder="Type custom unit type…"
        />
        {form.unitTypes.length > 0 && (
          <div style={{ fontSize: '.68rem', color: 'rgba(255,255,255,.28)', marginTop: 4 }}>
            {form.unitTypes.length} type{form.unitTypes.length !== 1 ? 's' : ''} selected
          </div>
        )}
      </div>

      {/* Amenities */}
      <div style={{ marginBottom: '1.4rem' }}>
        <TagInputField
          label="Amenities & Facilities"
          values={form.amenities}
          onChange={v => update({ amenities: v })}
          presets={AMENITIES}
          placeholder="Type custom amenity…"
        />
        {form.amenities.length > 0 && (
          <div style={{ fontSize: '.68rem', color: 'rgba(255,255,255,.28)', marginTop: 4 }}>
            {form.amenities.length} amenit{form.amenities.length !== 1 ? 'ies' : 'y'} selected
          </div>
        )}
      </div>

      {/* Total Area */}
      <div>
        <label style={LBL}>Total Project Area</label>
        <input
          id="step4-total-area"
          name="totalArea"
          style={INP}
          value={form.totalArea}
          onChange={e => update({ totalArea: e.target.value })}
          placeholder="e.g. 200 Acres or 840000 m²"
        />
      </div>
    </div>
  );
}
